// src/components/ReservationModal.jsx
import React from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  IconButton,
} from "@mui/material";
import {
  Close,
  Translate,
  Tour,
  CheckCircle,
  Navigation,
  NearMe,
} from "@mui/icons-material";
// Asegúrate de que no haya importaciones de framer-motion aquí
import { useReservationForm } from "../hook/useReservationForm";
import ExtraCitiesSelector from "./ExtraCitiesSelector";
import InterpretationCitiesSelector from "./InterpretationCitiesSelector";
import InterpretationTypesSelector from "./InterpretationTypesSelector";

const ReservationModal = ({ tour, onClose }) => {
  const {
    formData,
    isInterpretation,
    isSubmitted,
    isSending,
    availableExtraCities,
    INTERPRETATION_TYPES,
    handleChange,
    handleCheckbox,
    handleAddExtraCity,
    handleRemoveExtraCity,
    handleInterpretationCityInputChange,
    handleInterpretationCityKeyDown,
    handleRemoveInterpretationCity,
    handleAddInterpretationType,
    handleRemoveInterpretationType,
    handleSubmit,
    nameInputRef,
  } = useReservationForm(tour, onClose);

  return (
    <Modal open={true} onClose={onClose}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        px={1}
      >
        <Box
          className="bg-gradient-to-br from-purple-100 via-white to-purple-50 rounded-3xl p-4 sm:p-8 w-full sm:max-w-2xl mx-auto shadow-2xl border-4 border-purple-200 relative"
          sx={{
            outline: "none",
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 16, right: 16 }}
          >
            <Close />
          </IconButton>

          {!isSubmitted ? (
            <form className="space-y-5 pb-4" onSubmit={handleSubmit}>
              <Typography
                variant="h5"
                className="font-bold text-purple-800 flex items-center gap-2"
              >
                {isInterpretation ? <Translate /> : <Tour />}
                Reserva de {isInterpretation ? "Interpretación" : "Tour"}
              </Typography>

              <TextField
                label="Nombre completo"
                fullWidth
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                inputRef={nameInputRef}
              />
              <TextField
                label="Correo electrónico"
                fullWidth
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                type="email"
              />
              <TextField
                type="date"
                label="Fecha de inicio"
                fullWidth
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                required
              />
              <TextField
                type="date"
                label="Fecha de fin"
                fullWidth
                name="endDate"
                value={formData.endDate}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                required
              />

              {!isInterpretation ? (
                <>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.showCities}
                        onChange={handleCheckbox}
                        color="primary"
                      />
                    }
                    label="¿Deseas añadir ciudades adicionales?"
                  />
                  {formData.showCities && (
                    <ExtraCitiesSelector
                      extraCityInput={formData.extraCityInput}
                      customExtraCity={formData.customExtraCity}
                      selectedExtraCities={formData.selectedExtraCities}
                      availableExtraCities={availableExtraCities}
                      handleAddExtraCity={handleAddExtraCity}
                      handleRemoveExtraCity={handleRemoveExtraCity}
                      handleChange={handleChange}
                    />
                  )}
                </>
              ) : (
                <>
                  <InterpretationCitiesSelector
                    interpretationCityInput={formData.interpretationCityInput}
                    selectedInterpretationCities={
                      formData.selectedInterpretationCities
                    }
                    handleInterpretationCityInputChange={
                      handleInterpretationCityInputChange
                    }
                    handleInterpretationCityKeyDown={
                      handleInterpretationCityKeyDown
                    }
                    handleRemoveInterpretationCity={
                      handleRemoveInterpretationCity
                    }
                  />
                  <InterpretationTypesSelector
                    interpretationTypeInput={formData.interpretationTypeInput}
                    customInterpretationType={formData.customInterpretationType}
                    selectedInterpretationTypes={
                      formData.selectedInterpretationTypes
                    }
                    INTERPRETATION_TYPES={INTERPRETATION_TYPES}
                    handleChange={handleChange}
                    handleAddInterpretationType={handleAddInterpretationType}
                    handleRemoveInterpretationType={
                      handleRemoveInterpretationType
                    }
                  />
                </>
              )}

              <button
                type="submit"
                disabled={isSending}
                className={`w-full py-3 px-6 rounded-xl font-bold text-white transition-all duration-500 shadow-lg ${
                  isSending
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-gradient-to-r from-yellow-500 to-pink-500 hover:from-yellow-600 hover:to-pink-600 shadow-xl hover:shadow-2xl"
                }`}
              >
                {isSending ? "Enviando..." : "Enviar reserva"}
                {isSending ? (
                  <Navigation className="w-4 h-4 ml-2 inline-block" />
                ) : (
                  <NearMe className="w-4 h-4 ml-2 inline-block" />
                )}
              </button>
            </form>
          ) : (
            <div className="text-center text-purple-800">
              <CheckCircle className="text-green-500" sx={{ fontSize: 60 }} />
              <Typography variant="h6" className="mt-2 font-bold">
                ¡Reserva enviada con éxito!
              </Typography>
              <Typography variant="body2">
                Nos pondremos en contacto pronto.
              </Typography>
            </div>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ReservationModal;
